import { Card, Center, Loader } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'

import { PricingTiersDisplay } from '@/components/PricingTiersDisplay'
import { useGlobalState } from '@/hooks/useGlobalState'

export function PricingTab() {
  const { api } = useGlobalState()

  const plansQuery = useQuery({
    queryKey: ['plans'],
    queryFn: () => api.getPlans(),
    staleTime: 0,
    refetchOnMount: 'always',
  })

  const billingInfoQuery = useQuery({
    queryKey: ['billing', 'info'],
    queryFn: () => api.getBillingInfo(),
  })

  const isLoading = plansQuery.isLoading || billingInfoQuery.isLoading

  if (isLoading) {
    return (
      <Center h={400}>
        <Loader size="lg" />
      </Center>
    )
  }

  const billingInfo = billingInfoQuery.data?.billingInfo

  return (
    <Card shadow="sm" p="xl" radius="md" withBorder>
      <PricingTiersDisplay
        plans={plansQuery.data || []}
        currentUserCount={billingInfo?.currentSubscribers}
      />
    </Card>
  )
}
